import { GetMinesGameDetailsQuery } from '@/__generated__/graphql'

export const transformMinesGame = (data: GetMinesGameDetailsQuery['minesGame']) => {
  if (!data) {
    return null
  }

  return {
    id: data.id,
    result: data.status,
    bet: data.bet,
    denom: data.denom,
    player: data.player,
    date: data.created,
    win: data.payable,
    txHash: data.txHash,
    rtp: data.rtp,
    numberOfmines: data.mines,
    mines: unpack(data.minesLast),
    status: data.status,
    userChoices: unpack(
      data.minesGameRoundsByGameId.nodes.reduce((prev, curr) => prev + parseInt(curr?.userChoice), 0).toString() || '0'
    ),
  }
}

const unpack = (value: string) => {
  return Number(value)
    .toString(2)
    .padStart(32, '0')
    .split('')
    .map((x, i) => ({ value: x, index: i }))
    .filter((x) => x.value == '1')
    .map((x) => x.index)
}
